import React, { Component } from "react";

import {
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CSpinner,
  CRow,
  CCol
} from "@coreui/react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import Cards from "../Cards/Cards";
import TextCreator from "../Content/TextCreator";
import Widgets from "../Widgets/Widgets";

const FileDownload = require("js-file-download");

const appRoot = document.getElementById("root");

class ViewNodeModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // activity: null,
      loading: true,
      // textProduction: {
      //   id: "",
      //   show: false,
      //   value: [
      //     {
      //       type: "paragraph",
      //       children: [{ text: "" }]
      //     }
      //   ]
      // },
      activity_name: "",
      // contentId: "",
      // contentName: "",
      // item_id: null,
      textModal: false
    };

    this.el = document.createElement("div");
    this.error = this.error.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    appRoot.appendChild(this.el);

    const { id } = this.props;

    axios
      .get(`${URL.api}activity/activity/singleView/${id}`, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Origin": "*"
        }
      })
      .then(resp => {
        if (resp.data.success) {
          const activity = {
            ...resp.data.data,
            items: resp.data.data.items.map(item => ({
              ...item,
              title: item.name,
              subtitle: item.type_name
            }))
          };

          this.setState({
            loading: false,
            // activity,
            activity_name: activity.name,
            activity_description_box: {
              type: 0,
              text: activity.description
            },
            itens: activity.items
          });
        } else {
          this.error("Falha ao encontrar a atividade!");
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.error("Sua sessão expirou!");
          this.props.logout();
        } else {
          this.error("Falha ao encontrar a atividade!");
        }
      });
  }

  openItem = item => {
    if (item.type_id === 12) {
      window.open(`/question/list/prototype/${item.obj_id}`, "_blank");
    } else if (item.type_id === 15) {
      toastr.info(
        "Pré-visualização não disponível",
        'Conteúdo do tipo "Newton"'
      );
    } else if (item.type_id === 33) {
      this.setState({ lo_id: item.obj_id, textModal: true });
    } else if (item.type_id === 16 || item.type_id === 27) {
      axios
        .get(`${URL.api}content/los/singleView/${item.obj_id}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            window.open(resp.data.data.path, "_blank");
          },
          () => {
            toastr.error(
              "Falha",
              "Não foi possível abrir o link. Tente novamente!"
            );
          }
        );
    } else if (item.type_id === 14) {
      toastr.info(
        "Pré-visualização não disponível",
        'Conteúdo do tipo "Literarte"'
      );
    } else if (item.type_id === 18) {
      toastr.info(
        "Pré-visualização não disponível",
        'Conteúdo do tipo "Upload"'
      );
    } else if (item.type_id !== 17) {
      window.open(`/content/view/${item.obj_id}?title=${item.title}`, "_blank");
    } else {
      if (item.link?.endsWith(".pdf")) {
        window.open(item.link, "_blank");
      }

      const downloadPath = item.link
        ? item.link.substring(item.link.indexOf("uploads/") + 8)
        : `${item.obj_id === 1 ? "activity" : "repo"}/${item.name}`;

      axios
        .get(`${URL.api}download/${downloadPath}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` },
          responseType: "blob"
        })
        .then(resp => {
          FileDownload(resp.data, item.name);
        });
    }
  };

  componentWillUnmount() {
    appRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      <CModal
        show={this.props.show}
        onClose={() => this.props.onClose()}
        size="lg"
        centered
        style={{ overflow: "visible" }}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>Visualizar atividade</CModalTitle>
        </CModalHeader>
        <CModalBody style={{ overflow: "visible" }}>
          {this.state.loading ? (
            <div className="h-100 w-100 d-flex align-items-center justify-content-center p-4">
              <CSpinner size="md" color="secondary" />
            </div>
          ) : (
            <>
              <CRow className="flex-1 mt-3">
                <CCol lg="12">
                  <Cards
                    header={`${this.state.activity_name}`}
                    body={this.state.activity_description_box}
                    footer=""
                  />
                </CCol>
              </CRow>
              <CRow className="flex-1">
                <CCol lg="12">
                  <div id="leftSide">
                    <Widgets
                      itens={this.state.itens}
                      openItem={this.openItem}
                    />
                  </div>
                </CCol>
              </CRow>
            </>
          )}
        </CModalBody>
        {this.state.textModal && (
          <TextCreator
            show={this.state.textModal}
            onClose={() =>
              this.setState({
                textModal: false
                // currentLOLink: null
              })
            }
            // eslint-disable-next-line react/jsx-boolean-value
            showOnly={true}
            currentLOLink={this.state.lo_id}
          />
        )}
      </CModal>,
      this.el
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewNodeModal);
